import { createLogger } from "@kurrent-ui/utils";
const ICON_STORE = Symbol.for('c2-icon-store');
const ROOT = ':root';
const logger = createLogger('iconStore', 'orange');
class IconStore {
    constructor() {
        this.icons = new Map();
        this.has = (name, namespace = ROOT) => {
            return name in (this.icons.get(namespace) ?? {});
        };
        this.get = (name, namespace = ROOT) => {
            return this.icons.get(namespace)?.[name];
        };
        if (window[ICON_STORE] == null) {
            window[ICON_STORE] = this;
        }
    }
    addIcons(a, b) {
        const namespaced = typeof a === 'string' || typeof a === 'symbol';
        const namespace = namespaced ? a : ROOT;
        const icons = namespaced ? b : a;
        if (!this.icons.has(namespace)) {
            this.icons.set(namespace, {});
        }
        for (const key of Object.keys(icons)) {
            if (this.has(namespace, key)) {
                logger.error(`Duplicate icon ${key} added to iconStore${namespaced ? `in namespace ${String(namespace)}.` : ''}.`);
                continue;
            }
            Object.defineProperty(this.icons.get(namespace), key, Object.getOwnPropertyDescriptor(icons, key));
        }
    }
}
/**
 * Register icons for `c2-icon` to reference by name.
 * It is recommended to use [`@kurrent-ui/icon-manager`](/icon-manager) to manage your icons.
 */
export const iconStore = window[ICON_STORE] ?? new IconStore();
//# sourceMappingURL=iconStore.js.map
